/* =============================================================================
   T3BLOGG_OS — assets/boot.js
   0-100% loader + demon laugh (visual only). Reads section settings via
   data-* on #boot.
   ============================================================================= */

(function () {
  'use strict';
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);

  function shouldSkip(mode) {
    if (mode === 'never') return false;
    if (mode === 'always') return false;
    try {
      if (mode === 'first_visit') return sessionStorage.getItem('t3.booted') === '1';
      if (mode === 'first_visit_per_day') {
        const today = new Date().toISOString().slice(0, 10);
        return localStorage.getItem('t3.booted_day') === today;
      }
    } catch (e) {}
    return false;
  }
  function markBooted(mode) {
    try {
      sessionStorage.setItem('t3.booted', '1');
      if (mode === 'first_visit_per_day') {
        const today = new Date().toISOString().slice(0, 10);
        localStorage.setItem('t3.booted_day', today);
      }
    } catch (e) {}
  }

  // ---- Demon mouth-laugh frame cycler ----------------------------------
  let demonTimer = null;
  function startDemonLaugh() {
    const data = document.getElementById('t3-demon-data');
    const el   = document.getElementById('boot-demon');
    if (!data || !el) return;
    let frames;
    try { frames = JSON.parse(data.textContent); } catch (e) { return; }
    if (!Array.isArray(frames) || frames.length < 2) return;
    let i = 0;
    el.textContent = frames[0];
    demonTimer = setInterval(() => {
      i = (i + 1) % frames.length;
      el.textContent = frames[i];
    }, 180);
  }
  function stopDemonLaugh() {
    if (demonTimer) { clearInterval(demonTimer); demonTimer = null; }
  }

  function runBoot() {
    const overlay = $('#boot');
    if (!overlay) return;

    const mode = overlay.dataset.skipMode || 'first_visit';
    const respectRM = overlay.dataset.respectRm !== 'false';
    const duration = parseInt(overlay.dataset.duration || '6000', 10);
    const showDemon = overlay.dataset.showDemon !== 'false';
    const demonHold = parseInt(overlay.dataset.demonHold || '1500', 10);

    if (mode === 'never' || (respectRM && REDUCED) || shouldSkip(mode)) {
      overlay.classList.add('gone');
      markBooted(mode);
      return;
    }

    const fill = $('#boot-fill');
    const pct = $('#boot-pct');
    const status = $('#boot-status');
    const blob = $('#boot-blob');
    const demonEl = $('#boot-demon');

    let tasks = ['mounting /home/anon'];
    try {
      const raw = $('#boot-tasks');
      if (raw) tasks = JSON.parse(raw.textContent) || tasks;
    } catch (e) {}

    let skipped = false;
    function finish() {
      if (skipped) return;
      skipped = true;
      stopDemonLaugh();
      overlay.classList.add('wipe');
      setTimeout(() => {
        overlay.classList.add('gone');
        markBooted(mode);
        document.dispatchEvent(new CustomEvent('boot:done'));
      }, 260);
    }
    overlay.addEventListener('click', finish);
    document.addEventListener('keydown', finish, { once: true });

    const start = performance.now();
    let taskIdx = 0;
    let lastTask = 0;

    function frame(now) {
      if (skipped) return;
      let t = (now - start) / duration;
      if (t > 1) t = 1;
      const eased = t < .33 ? t * 1.05 : t < .35 ? .33 + (t-.33)*.2 :
                    t < .68 ? .35 + (t-.35) * 1.0 : t < .72 ? .68 + (t-.68)*.2 :
                    t;
      const p = Math.min(100, Math.floor(eased * 100));
      if (fill) fill.style.width = p + '%';
      if (pct) pct.textContent = String(p).padStart(3, ' ') + ' %';

      if (now - lastTask > 180 && taskIdx < tasks.length) {
        const line = `[ ${(Math.random()*0.999).toFixed(3)}] ${tasks[taskIdx]}`;
        if (blob) blob.textContent = (blob.textContent + '\n' + line).split('\n').slice(-6).join('\n');
        if (status) status.textContent = '> ' + tasks[taskIdx];
        taskIdx++;
        lastTask = now;
      }

      if (t >= 1) {
        if (status) status.textContent = '> ACCESS_GRANTED';
        setTimeout(() => {
          if (skipped) return;
          if (showDemon && demonEl && demonEl.textContent.trim()) {
            overlay.classList.add('show-demon');
            startDemonLaugh();
            setTimeout(finish, demonHold);
          } else {
            finish();
          }
        }, 300);
        return;
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBoot);
  } else {
    runBoot();
  }
})();
